import { useState, useRef } from 'react';
import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';

const testimonials = [
  {
    name: '小糖豆',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20in%20pastel%20pink%20style%2C%20soft%20colors%2C%20kawaii%20portrait%2C%20simple%20background&width=100&height=100&seq=avatar-1&orientation=squarish',
    rating: 5,
    content: '在这里发现了超多宝藏小说！《猫系少女的甜蜜日常》简直是我的本命小说，每天追更都超开心。推荐给所有喜欢可爱故事的姐妹们！',
    date: '2024年7月',
  },
  {
    name: '棉花糖',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20with%20round%20glasses%2C%20pastel%20cream%20colors%2C%20kawaii%20portrait%2C%20simple%20background&width=100&height=100&seq=avatar-2&orientation=squarish',
    rating: 5,
    content: '分类做得特别好，想找甜宠小说一目了然。已经把这个网站安利给身边所有爱看小说的朋友了，她们都说好！',
    date: '2024年6月',
  },
  {
    name: '星星酱',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20with%20twin%20tails%2C%20soft%20peach%20colors%2C%20kawaii%20portrait%2C%20simple%20background&width=100&height=100&seq=avatar-3&orientation=squarish',
    rating: 5,
    content: '治愈系分类里的每本书都好温柔！压力大的时候就翻出来看看，感觉被暖暖的拥抱包围了。感谢小编们的用心推荐！',
    date: '2024年6月',
  },
  {
    name: '布丁奶茶',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20smiling%2C%20soft%20lavender%20colors%2C%20kawaii%20portrait%2C%20simple%20background&width=100&height=100&seq=avatar-4&orientation=squarish',
    rating: 4,
    content: '更新频率很高，每周都有新书推荐。书单的质量也很稳定，基本没有踩过雷。希望能加入读者评论功能，想和小伙伴们交流读后感！',
    date: '2024年5月',
  },
  {
    name: '桃子苏打',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20with%20pink%20hair%2C%20soft%20pastel%20colors%2C%20kawaii%20portrait%2C%20simple%20background&width=100&height=100&seq=avatar-5&orientation=squarish',
    rating: 5,
    content: '作为一个甜宠小说重度爱好者，这个网站简直就是我的天堂！每本书的介绍都写得很有吸引力，而且推荐的确实都是精品。墙裂推荐！',
    date: '2024年7月',
  },
  {
    name: '柠檬薄荷',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20with%20green%20eyes%2C%20soft%20mint%20colors%2C%20kawaii%20portrait%2C%20simple%20background&width=100&height=100&seq=avatar-6&orientation=squarish',
    rating: 4,
    content: '奇幻分类给了我很多惊喜！《龙族公主的甜味冒险》脑洞超大但又不失温暖，这种类型的可爱小说真的很少见。期待更多奇幻类的推荐！',
    date: '2024年5月',
  },
  {
    name: '奶油草莓',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20with%20red%20hair%20ribbon%2C%20soft%20warm%20colors%2C%20kawaii%20portrait%2C%20simple%20background&width=100&height=100&seq=avatar-7&orientation=squarish',
    rating: 5,
    content: '最喜欢校园分类了！《同桌是只小奶狗》读了三遍都不腻，青春的酸甜感太真实了。这个网站推荐的书真的都很有品味。',
    date: '2024年7月',
  },
  {
    name: '蜜桃多多',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20girl%20avatar%20with%20braided%20hair%2C%20soft%20peach%20colors%2C%20kawaii%20portrait%2C%20simple%20background&width=100&height=100&seq=avatar-8&orientation=squarish',
    rating: 5,
    content: '网页设计也很可爱，浏览体验超级好！每次点进来都感觉心情变好了。希望能一直更新下去，会一直支持你们的！',
    date: '2024年8月',
  },
];

const stats = [
  { value: '500+', label: '精选小说' },
  { value: '128,000+', label: '活跃读者' },
  { value: '50+', label: '合作作者' },
  { value: '99.2%', label: '好评率' },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const formRef = useRef<HTMLFormElement>(null);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }

    formData.delete('phone_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9rg4ffnahb7382ovm1g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setFormStatus('error');
        if (serverMsg && (serverMsg.includes('spam') || serverMsg.includes('form data is spam'))) {
          setFormError('提交失败，请稍后重试。');
        } else {
          setFormError(serverMsg || '提交失败，请稍后重试。');
        }
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查连接后重试。');
    }
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '可爱小说推荐',
    url: 'https://keaixiaoshuo.com',
    description: '最萌治愈系小说推荐平台，专注于可爱小说的精选推荐。',
    foundingDate: '2023',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'hello@keaixiaoshuo.com',
      availableLanguage: ['Chinese'],
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '如何向可爱小说推荐平台投稿或推荐小说？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过本页面的联系表单提交小说推荐，或者发送邮件至 hello@keaixiaoshuo.com。我们的编辑团队会认真审核每一份推荐，优质作品将有机会被收录到网站书单中。',
        },
      },
      {
        '@type': 'Question',
        name: '可爱小说推荐平台是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，可爱小说推荐平台对所有读者完全免费开放。我们致力于为可爱小说爱好者提供最优质的书单推荐服务，不收取任何费用。',
        },
      },
    ],
  };

  return (
    <>
      <SEO
        title="关于我们 - 可爱小说推荐 | 品牌介绍与联系方式"
        description="可爱小说推荐平台专注于精选最萌治愈系小说合集，涵盖甜宠、萌系、治愈系等多种风格。了解我们的品牌故事、读者口碑评价，以及联系方式。"
        keywords="可爱小说推荐,关于我们,品牌介绍,联系方式,读者评价"
        canonicalUrl="https://keaixiaoshuo.com/about"
      />
      <ScrollToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero */}
        <section className="pt-20 md:pt-24 pb-8 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <Breadcrumb
              items={[
                { name: '首页', path: '/' },
                { name: '关于我们' },
              ]}
            />
          </div>
          <div className="max-w-3xl mx-auto px-4 md:px-6 py-8 text-center">
            <h1 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
              关于我们
            </h1>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
              可爱小说推荐 —— 最萌治愈系小说合集平台
            </p>
          </div>
        </section>

        {/* Stats */}
        <section className="w-full px-4 md:px-6 py-8 md:py-10">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="text-center p-4 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <p className="text-xl md:text-3xl font-heading text-primary-500 mb-1">{stat.value}</p>
                  <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Brand Story */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6 text-center">
              品牌故事
            </h2>
            <div className="flex flex-col gap-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                可爱小说推荐平台诞生于2023年，由一群热爱可爱小说的资深读者共同创建。我们发现，虽然网络上有海量的小说推荐，但专门为可爱、萌系、治愈风格小说定制的推荐平台却少之又少。于是，我们决定亲手打造一个专注于可爱小说的精品推荐网站。
              </p>
              <p>
                我们的编辑团队由多位拥有十年以上阅读经验的资深书虫组成。每一本被收录到网站的小说，都需要经过至少三位编辑的独立评审，确保内容优质、风格可爱、情节温暖。我们坚持质量优先的原则，宁缺毋滥，只为给读者带来最好的阅读推荐。
              </p>
              <p>
                从上线至今，可爱小说推荐已经收录了超过500本精选可爱小说，服务了超过12万活跃读者。我们收到了无数温暖的反馈——有人说在这里找到了治愈焦虑的良药，有人说在这里发现了陪伴自己度过艰难时光的好书。这些声音，就是我们不断前行的动力。
              </p>
              <p>
                未来，可爱小说推荐将继续深耕可爱小说领域，拓展更多风格分类，邀请更多优秀作者合作，为读者带来更加丰富多彩的阅读体验。我们相信，每一个温柔的故事都值得被看见，每一个可爱的角色都值得被喜爱。
              </p>
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6 text-center">
              读者口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
              {testimonials.map((t, i) => (
                <div
                  key={i}
                  className="p-4 md:p-5 rounded-lg bg-background-50 border border-background-200/70"
                >
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" loading="lazy" />
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <div className="flex items-center gap-0.5">
                        {Array.from({ length: t.rating }).map((_, j) => (
                          <i key={j} className="ri-star-fill text-amber-400 text-xs"></i>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
                  <p className="text-xs text-foreground-400 mt-3">{t.date}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-2 text-center">
              联系我们
            </h2>
            <p className="text-sm text-foreground-500 mb-8 text-center">
              有任何建议、合作意向或想推荐小说？欢迎随时联系我们！
            </p>

            <form ref={formRef} onSubmit={handleSubmit} data-readdy-form="true" className="flex flex-col gap-4">
              <input type="text" name="form_name" value="About Contact Form" readOnly className="hidden" />

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="contact-name" className="text-sm font-medium text-foreground-800">
                    姓名 <span className="text-red-400">*</span>
                  </label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    placeholder="请输入您的姓名"
                    className="px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors"
                  />
                </div>
                <div className="flex flex-col gap-1.5">
                  <label htmlFor="contact-email" className="text-sm font-medium text-foreground-800">
                    邮箱 <span className="text-red-400">*</span>
                  </label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    placeholder="请输入您的邮箱"
                    className="px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors"
                  />
                </div>
              </div>

              <div className="flex flex-col gap-1.5">
                <label htmlFor="contact-subject" className="text-sm font-medium text-foreground-800">
                  主题
                </label>
                <input
                  id="contact-subject"
                  name="subject"
                  type="text"
                  placeholder="请输入主题"
                  className="px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors"
                />
              </div>

              <div className="flex flex-col gap-1.5">
                <label htmlFor="contact-message" className="text-sm font-medium text-foreground-800">
                  留言 <span className="text-red-400">*</span>
                </label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  rows={5}
                  maxLength={500}
                  placeholder="请输入您的留言（最多500字）"
                  className="px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-colors resize-none"
                ></textarea>
                <p className="text-xs text-foreground-400">最多500字</p>
              </div>

              {/* Honeypot */}
              <div className="honeypot-field">
                <label htmlFor="phone_alt">备用电话</label>
                <input
                  type="text"
                  id="phone_alt"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>

              {formStatus === 'success' && (
                <div className="p-4 rounded-lg bg-green-50 border border-green-200 text-sm text-green-700">
                  提交成功！感谢您的留言，我们会尽快回复您。
                </div>
              )}

              {formStatus === 'error' && (
                <div className="p-4 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">
                  {formError}
                </div>
              )}

              <button
                type="submit"
                className="px-6 py-2.5 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                发送留言
              </button>
            </form>
          </div>
        </section>

        {/* FAQ */}
        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-6 text-center">
              常见问题
            </h2>
            <div className="flex flex-col gap-3 md:gap-4">
              <details className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer">
                <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-900 list-none">
                  如何向可爱小说推荐平台投稿或推荐小说？
                  <i className="ri-arrow-down-s-line text-lg text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  您可以通过本页面的联系表单提交小说推荐，或者发送邮件至 hello@keaixiaoshuo.com。我们的编辑团队会认真审核每一份推荐，优质作品将有机会被收录到网站书单中。
                </div>
              </details>
              <details className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer">
                <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-900 list-none">
                  可爱小说推荐平台是免费的吗？
                  <i className="ri-arrow-down-s-line text-lg text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  是的，可爱小说推荐平台对所有读者完全免费开放。我们致力于为可爱小说爱好者提供最优质的书单推荐服务，不收取任何费用。
                </div>
              </details>
              <details className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer">
                <summary className="flex items-center justify-between px-5 py-4 text-sm md:text-base font-medium text-foreground-900 list-none">
                  如何成为平台的合作作者？
                  <i className="ri-arrow-down-s-line text-lg text-foreground-400 group-open:rotate-180 transition-transform duration-200"></i>
                </summary>
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  欢迎各位可爱小说作者通过联系表单或邮件与我们取得联系。请附上您的作品简介和样章，我们的编辑团队会在3个工作日内回复您。
                </div>
              </details>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}